module.exports = __webpack_public_path__ + "media/images/prestaciones/celiacos-50a895960edc000dd9ca99f833045912.svg";